<script>
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
</script>

<div class="flex items-center gap-1 py-4 px-2">
	<SkeletonBlock width="20px" height="20px" />
	<SkeletonBlock width="140px" height="20px" />
</div>
<div class="py-4 px-2 flex flex-col gap-4">
	<div class="flex justify-between">
		<SkeletonBlock width="120px" height="16px" />
		<SkeletonBlock width="120px" height="16px" />
	</div>
	<SkeletonBlock width="full" height="20px" />
</div>
<div class="py-4 px-2 flex flex-col gap-4">
	<div class="flex justify-between">
		<SkeletonBlock width="120px" height="16px" />
		<SkeletonBlock width="120px" height="16px" />
	</div>
	<SkeletonBlock width="full" height="20px" />
</div>
<div class="py-4 px-2 flex flex-col gap-4">
	<div class="flex justify-between">
		<SkeletonBlock width="120px" height="16px" />
		<SkeletonBlock width="120px" height="16px" />
	</div>
	<SkeletonBlock width="full" height="20px" />
</div>
